import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

interface BreadcrumbItem {
  name: string;
  path: string;
}

export default function Breadcrumb() {
  const location = useLocation();
  const pathSegments = location.pathname.split('/').filter(Boolean);

  const breadcrumbs: BreadcrumbItem[] = [{ name: '首页', path: '/' }];

  if (pathSegments.length > 0) {
    if (pathSegments[0] === 'category' && pathSegments[1]) {
      const cat = categories.find((c) => c.slug === pathSegments[1]);
      breadcrumbs.push({
        name: cat ? cat.name : pathSegments[1],
        path: `/category/${pathSegments[1]}`,
      });
    } else if (pathSegments[0] === 'article' && pathSegments[1]) {
      breadcrumbs.push({
        name: '视频详情',
        path: location.pathname,
      });
    } else if (pathSegments[0] === 'about') {
      breadcrumbs.push({
        name: '关于我们',
        path: '/about',
      });
    }
  }

  if (breadcrumbs.length <= 1) return null;

  return (
    <nav aria-label="面包屑导航" className="w-full px-4 md:px-6 pt-20 pb-2">
      <ol className="flex items-center flex-wrap gap-1 text-sm">
        {breadcrumbs.map((item, index) => {
          const isLast = index === breadcrumbs.length - 1;
          return (
            <li key={item.path} className="flex items-center gap-1">
              {index > 0 && (
                <span className="text-foreground-300 mx-1">
                  <i className="ri-arrow-right-s-line text-xs"></i>
                </span>
              )}
              {isLast ? (
                <span className="text-foreground-600 font-medium">
                  {item.name}
                </span>
              ) : (
                <Link
                  to={item.path}
                  className="text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer"
                >
                  {item.name}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}